import { BrandclubEventType } from './types.js';

var debug = false;
var initialized = false;
var loaderScript = null;
var initScript = null;
var PROVIDER = 'TheTradeDesk';
var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!debug) {
        return;
    }
    // eslint-disable-next-line no-console
    console.info.apply(console, ['[TTD]'].concat(args));
};
function initializeTDDPixel(brandId, pixelLoadUrl, initArgs) {
    if (!initialized && brandId && pixelLoadUrl && initArgs) {
        initialized = true;
        loaderScript = document.createElement('script');
        loaderScript.type = 'text/javascript';
        loaderScript.src = pixelLoadUrl;
        document.body.appendChild(loaderScript);
        loaderScript.onload = function () {
            log('initializeTDDPixel', brandId, pixelLoadUrl, initArgs);
            initScript = document.createElement('script');
            initScript.type = 'text/javascript';
            initScript.innerHTML = "ttd_dom_ready(function() {\n            if (typeof TTDUniversalPixelApi === 'function') {\n            var universalPixelApi = new TTDUniversalPixelApi();\n            universalPixelApi.init(\n                ".concat(JSON.stringify(initArgs[0]), ",\n                ").concat(JSON.stringify(initArgs[1]), ",\n                ").concat(JSON.stringify(initArgs[2]), "\n            );\n        }});");
            document.body.appendChild(initScript);
        };
    }
}
var tddPixel = {
    enableDebug: function () {
        debug = true;
    },
    track: function (_a) {
        var brandId = _a.brandId, pixels = _a.pixels, eventName = _a.eventName, eventType = _a.eventType, eventPayload = _a.eventPayload;
        var pixel = pixels === null || pixels === void 0 ? void 0 : pixels.find(function (item) { return item.pixelProvider === PROVIDER; });
        if (!pixel) {
            return;
        }
        log(JSON.stringify({ brandId: brandId, pixels: pixels, eventName: eventName, payload: eventPayload }));
        initializeTDDPixel(brandId, pixel === null || pixel === void 0 ? void 0 : pixel.pixelLoadUrl, (pixel === null || pixel === void 0 ? void 0 : pixel.pixelInitArgs) ? JSON.parse(pixel.pixelInitArgs) : []);
        if (eventType === BrandclubEventType.PageView) {
            initializeTDDPixel(brandId, pixel === null || pixel === void 0 ? void 0 : pixel.pixelLoadUrl, (pixel === null || pixel === void 0 ? void 0 : pixel.pixelInitArgs) ? JSON.parse(pixel.pixelInitArgs) : []);
        }
        else if (eventType === BrandclubEventType.OrderSubmitted || eventType === BrandclubEventType.AddToCart) {
            initializeTDDPixel(brandId, pixel === null || pixel === void 0 ? void 0 : pixel.pixelLoadUrl, (pixel === null || pixel === void 0 ? void 0 : pixel.pixelInitArgs) ? JSON.parse(pixel.pixelInitArgs) : []);
        }
    },
};

export { tddPixel as default };
//# sourceMappingURL=tdd.js.map
